import React, { Component } from 'react'
import { Field, reduxForm, SubmissionError } from 'redux-form'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { getAreas } from "../../actions/constant";

import TextInput from '../inputs/TextInput'
import SelectInput from "../inputs/SelectInput";
import DateInput from "../inputs/DateInput";
import CheckBox from '../inputs/CheckBox';
import * as validate from "../util/Validator";
import { Link, Button } from "../util/Clickable";
import { settings } from "../../assets/settings";

class SearchHeaderForm extends Component {

  state = {
    loading: false,
    regions: null,
    prefectures: null,
    largeAreas: null
  }

  componentDidMount = () => {
    if( this.props.constant.areas.length == 0 ){
      this.props.actions.getAreas().then( ({value}) => {
        this.setRegions(value.data, ( this.props.formState && this.props.formState.values ) ? this.props.formState.values: this.props.initialValues);
      });
    }else{
      this.setRegions( this.props.constant.areas, ( this.props.formState && this.props.formState.values ) ? this.props.formState.values: this.props.initialValues );
    }
  }

  setRegions = (regions, values) => {
    if( values == null ){
      values = {};
    }
    const regionId = values.region_id;
    const prefectureId = values.prefecture_id;

    var prefectures = null;
    var largeAreas = null;
    var regions = regions.map( (region, index) => {
      if(region.id == regionId ){
        prefectures = region.prefectures.map( (prefecture, index) => {
          if(prefecture.id == prefectureId ){
            largeAreas = prefecture.large_areas.map( (large_area) => {
              return {value: large_area.id, label: large_area.label };
            });
          }
          return {value: prefecture.id, label: prefecture.label };
        });
      }
      return {value: region.id, label: region.label };
    });

    this.setState({
      regions: regions,
      prefectures: prefectures,
      largeAreas: largeAreas
    });
  }

  componentWillReceiveProps = (nextProps) => {
    if( nextProps.formState == null || this.props.formState == null || nextProps.formState.values == null || this.props.formState.values == null ){
      return;
    }
    if(
      ( nextProps.formState.values.region_id != this.props.formState.values.region_id ) 
      || ( nextProps.formState.values.prefecture_id != this.props.formState.values.prefecture_id )  
      || ( nextProps.formState.values.large_area_id != this.props.formState.values.large_area_id ) 
    ){
      this.setRegions(nextProps.constant.areas, nextProps.formState.values);
    }
  }

  onSubmit = ( values ) => {
    return this.props.onSubmit(this.props.formState.values);
  }

  render = () => {
    return (
      <form>
        <div className="uk-margin uk-grid-small uk-flex-middle" data-uk-grid>
          <div className="uk-width-1-1">
            <label className="uk-text-bold">施設名・キーワード</label>
          </div>
          <div className="uk-width-1-1">
            <Field name="name" type="text" component={TextInput} validate={[]} />
          </div>
        </div>
        <div className="uk-margin uk-grid-small uk-flex-middle" data-uk-grid>
          <div className="uk-width-1-1">
          </div>
          <div className="uk-width-1-1">
            {
              this.state.regions && (
                <Field 
                  name="region_id" component={SelectInput} validate={[]}
                >
                  <option value="">未選択</option>
                  {
                    this.state.regions.map( (option, index) => {
                      return (
                        <option key={index} value={option.value}>{option.label}</option>
                      );
                    })
                  }
                </Field>
              )
            }
          </div>
          <div className="uk-width-1-1">
            {
              this.state.prefectures && (
                <Field 
                  name="prefecture_id" component={SelectInput} validate={[]}
                >
                  <option value="">未選択</option>
                  {
                    this.state.prefectures.map( (option, index) => {
                      return (
                        <option key={index} value={option.value}>{option.label}</option>
                      );
                    })
                  }
                </Field>
              )
            }
          </div>
          <div className="uk-width-1-1">
            {
              this.state.largeAreas && (
                <Field 
                  name="large_area_id" component={SelectInput} options={[]} validate={[]}
                >
                  <option value="">未選択</option>
                  {
                    this.state.largeAreas.map( (option, index) => {
                      return (
                        <option key={index} value={option.value}>{option.label}</option>
                      );
                    })
                  }
                </Field>
              )
            }
          </div>
        </div>


        <div className="uk-margin uk-grid-small uk-flex-middle" data-uk-grid>
          <div className="uk-width-1-1">
            <label className="uk-text-bold">チェックイン日</label>
          </div>
          <div className="uk-width-1-1">
            <DateInput name="checkin_at" />
          </div>
        </div>

        <div className="uk-margin uk-grid-small uk-flex-middle" data-uk-grid>
          <div className="uk-width-1-1">
            <label className="uk-text-bold">宿泊数</label>
          </div>
          <div className="uk-width-expand">
            <Field 
              name="stay_date" component={TextInput} validate={[]}
            />
          </div>
          <div className="uk-width-auto">
            <span className="uk-text-bold">泊</span>
          </div>
        </div>
        <div className="uk-margin uk-grid-small uk-flex-middle" data-uk-grid>
          <div className="uk-width-1-1">
            <label className="uk-text-bold">大人人数</label>
          </div>
          <div className="uk-width-expand">
            <Field 
              name="adult_num" component={TextInput} validate={[]}
            />
          </div>
          <div className="uk-width-auto">
            <span className="uk-text-bold">人</span>
          </div>
        </div>

        {
          settings.detail_search.length > 0 && (
            <div className="uk-margin uk-grid-small uk-flex-middle" data-uk-grid>
              <div className="uk-width-1-1">
                <label className="uk-text-bold">詳細条件</label>
              </div>
              <div className="uk-width-expand">
                {
                  settings.detail_search.map( (data, index) => {
                    return (
                      <div key={index} className="uk-margin-xsmall">
                        <Field name={data.name} label={data.label} component={CheckBox} />
                      </div>      
                    );
                  })
                }
              </div>
            </div>
          )
        }
        
        {(()=>{
          if( this.props.error ){
            return (
              <div className="uk-margin-small uk-text-danger uk-text-center@s">
                <span>
                  { this.props.error }
                </span>
              </div> 
            );
          }
        } )() }
        <div className="uk-margin-top">
          <Button className="uk-button uk-button-primary uk-width-1-1" type="button" disabled={this.props.invalid} loading={this.state.loading ? 1: 0} onClick={this.onSubmit}>
            検索
          </Button>
        </div>
      </form>
    )
  }
}

const mapStateToProps = state => {
  return {
    constant: state.constant,
    formState: state.form.searchHeaderForm, 
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    getAreas: (data) => dispatch( getAreas(data) )
  }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
  form: 'searchHeaderForm',
  enableReinitialize : true
})(SearchHeaderForm))